import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "pagestyle" }

import { reactive, onMounted } from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import api from '@/api/index'
  import {useRouter} from 'vue-router'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

  const router = useRouter()
  const searchForm:any = reactive({
    limit:10,
    page:1,
  })
  const baseData:any = reactive({
    loading:false,
    title:'',
  })
  const tableData:any = reactive({
    data:[],
    total:0,
  })
  const handleSizeChange = (val:number) => {
    searchForm.limit = val
    searchForm.page = 1
    getList()
  }
  const handleCurrentChange = (val:any) => {
    searchForm.page = val
    getList()
  }
  const getList = () => {
    localStorage.setItem('qapage',searchForm.page);
    localStorage.setItem('qalimit',searchForm.limit);
    baseData.loading = true
    api.qaApi.list(searchForm).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        tableData.data = res.data.list
        tableData.total = res.data.total
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const add = () => {
    router.push("/qa/add");
  }
  const edit = (id:any) => {
    router.push("/qa/edit/"+id);
  }
  const del = (id:number) => {
    baseData.loading = true
    api.qaApi.del({id:id}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  onMounted(() => {
    searchForm.page = localStorage.getItem('qapage')&&localStorage.getItem('qapage')!=null&&localStorage.getItem('qapage')!='null' ? parseInt(localStorage.getItem('qapage') ): 1;
    searchForm.limit = localStorage.getItem('qalimit')&&localStorage.getItem('qalimit')!=null&&localStorage.getItem('qalimit')!='null' ? parseInt(localStorage.getItem('qalimit')) : 10;
    getList()
  })
  
return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, { shadow: "never" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_breadcrumb, {
            class: "breadcrumb",
            separator: "/"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
                default: _withCtx(() => [
                  _createTextVNode("工作台")
                ]),
                _: 1
              }),
              _createVNode(_component_el_breadcrumb_item, null, {
                default: _withCtx(() => [
                  _createTextVNode("问题答疑")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "editbtn",
            onClick: add
          }, {
            default: _withCtx(() => [
              _createTextVNode("新增")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"20px"}
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          "row-key": "id",
          border: "",
          data: tableData.data,
          style: {"width":"100%","margin-top":"10px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "id",
              label: "ID",
              width: "60"
            }),
            _createVNode(_component_el_table_column, {
              prop: "title",
              label: "标题"
            }),
            _createVNode(_component_el_table_column, {
              prop: "addTime",
              label: "时间",
              width: "110"
            }),
            _createVNode(_component_el_table_column, {
              label: "状态",
              width: "80"
            }, {
              default: _withCtx((scope) => [
                (scope.row.status == 1)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_2, "正常"))
                  : (_openBlock(), _createElementBlock("p", _hoisted_3, "下架"))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              label: "操作",
              width: "180"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: ($event: any) => (edit(scope.row.id)),
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("编辑")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_popconfirm, {
                  "confirm-button-text": "是",
                  "cancel-button-text": "否",
                  title: "确定删除吗?",
                  onConfirm: ($event: any) => (del(scope.row.id))
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "danger"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onConfirm"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, baseData.loading]
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_pagination, {
            "current-page": searchForm.page,
            "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.page) = $event)),
            "page-size": searchForm.limit,
            "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((searchForm.limit) = $event)),
            layout: "sizes, prev, pager, next",
            total: tableData.total,
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange
          }, null, 8, ["current-page", "page-size", "total"])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})